export const radioOptions = {
  'small-site': 'Small construction site',
  'large-site': 'Large scale construction site',
  'state-critical':
    'Critical and essential infrastructure project (including a State Critical Infrastructure Project)',
  'early-development': 'Early Development Site'
};
